import React from "react";
import { useTranslation } from "react-i18next";

// Shared with the mobile preferences menu in NavbarButtons
export const useLanguageToggle = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language.startsWith("en");

  const toggle = () => {
    const next = isEnglish ? "fr" : "en";
    i18n.changeLanguage(next);
    localStorage.setItem("selectedLanguage", next);
  };

  return { isEnglish, toggle };
};

const LanguageToggle = () => {
  const { isEnglish, toggle } = useLanguageToggle();
  const label = isEnglish ? "FR" : "EN";

  return (
    <button
      onClick={toggle}
      className="tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-[#712CB0]/20 tw-border tw-border-[#712CB0]/50 tw-text-white tw-text-xs tw-font-bold tw-cursor-pointer hover:tw-bg-[#712CB0]/40 hover:tw-border-[#712CB0]/80 tw-transition-all tw-shrink-0"
    >
      {label}
    </button>
  );
};

export default LanguageToggle;
